import { Button, Col, Form, Input, Modal, Row, Select, Switch, Upload } from "antd";
import config from "../../../../../config";
import { useState, useEffect, useRef } from "react";
import * as Validation from "../../../../../utils/helper/validation";
import * as Apis from "../../../../../utils/helper/enum";
import { changeLoader } from "../../../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import globalRequest from "../../../../../utils/global/globalRequest";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";
import { selectTime } from "../../../../../utils/helper/constants";

const DriverPersonalDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [previewImage, setPreviewImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [allZones, setAllZones] = useState([]);
  const [allVehicleType, setAllVehicleType] = useState([]);
  const [selectType, setSelectType] = useState("");

  const cropperRef = useRef(null);
  const [image, setImage] = useState(null);
  const [changePassword, setChangePassword] = useState(false);

  let { id } = useParams();

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
  };

  const handleUpload = ({ file }) => {
    const maxSize = 5 * 1024 * 1024; // 5 MB in bytes
    if (file.size > maxSize) {
      // Show an error message or notification
      toast.error("File size must be less than 5 MB.");
      return false; // Prevent adding the file to the file list
    }

    if (file.status === "removed") return false;
    // setImageData({ imagename: file.name, imagetype: file.type });
    const reader = new FileReader();
    reader.onload = () => setImage(reader.result);
    reader.readAsDataURL(file);
    setPreviewOpen(true);
    return false; // Prevent automatic upload
  };

  const handleCrop = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      const canvas = cropper.getCroppedCanvas({
        width: 500, // Reduce width (Adjust as needed)
        height: 500, // Reduce height
      });
      const croppedImage = canvas.toDataURL("image/jpeg", 0.7); // Lower quality to 70%
      setFileList([
        {
          uid: "-1",
          name: "image.png",
          status: "done",
          url: croppedImage,
        },
      ]);
      setPreviewOpen(false);
      setPreviewImage(croppedImage);

      form.setFields([
        {
          name: "profile_image",
          errors: [""],
        },
      ]);
    }
  };

  const handleRemove = (file) => {
    setFileList([]);
    setPreviewImage("");
    setPreviewOpen(false);
  };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <img src={previewImage ? previewImage : config.IMAGEBASEURL + `images/upload-img.png`} alt="Upload" />
    </button>
  );

  const getAllZones = async () => {
    try {
      let response = await globalRequest(Apis.MANAGE_DRIVERS.GET_ALL_ZONES, "get", {}, {}, true);
      let apiResponse = response?.data;
      let data = apiResponse?.data?.data?.map((item) => {
        return {
          value: item?.id,
          label: item?.name,
        };
      });
      setAllZones(data);
    } catch (e) {
      toast.error(e?.message);
    }
  };
  const getAllVehicles = async () => {
    try {
      let response = await globalRequest(Apis.MANAGE_DRIVERS.GET_ALL_VEHICLE, "get", {}, {}, true);
      let apiResponse = response?.data;

      let data = apiResponse?.data?.data?.map((item) => {
        return {
          value: item?.id,
          label: item?.name,
          type: item.deliveryType,
        };
      });
      setAllVehicleType(data);
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const validateSlots = () => {
    let hasError = false;
    const updatedSlots = timeFields.map((slot) => ({ ...slot })); // Create a shallow copy of the array

    updatedSlots.forEach((slot, index) => {
      if (!slot.openTime) {
        updatedSlots[index].openTimeErr = "Open time is required.";
        hasError = true;
      } else {
        updatedSlots[index].openTimeErr = ""; // Clear any previous error
      }

      if (!slot.closeTime) {
        updatedSlots[index].closeTimeErr = "Close time is required.";
        hasError = true;
      } else {
        updatedSlots[index].closeTimeErr = ""; // Clear any previous error
      }

      if (!slot.total_trip_distance) {
        updatedSlots[index].total_trip_distanceErr = "Total trip distance is required.";
        hasError = true;
      } else {
        updatedSlots[index].closeTimeErr = ""; // Clear any previous error
      }

      // Validate that closeTime is greater than openTime
      if (slot.openTime && slot.closeTime && slot.closeTime <= slot.openTime) {
        updatedSlots[index].closeTimeErr = "Close time must be greater than open time.";
        hasError = true;
      } else if (slot.openTime && slot.closeTime) {
        updatedSlots[index].closeTimeErr = ""; // Clear any previous error
      }

      // Validate time slot overlaps
      let overlapError = false; // Track overlap for this slot

      updatedSlots.forEach((otherSlot, otherIndex) => {
        if (index !== otherIndex) {
          // Check if the time slots overlap
          if (
            (slot.openTime >= otherSlot.openTime && slot.openTime < otherSlot.closeTime) || // Current slot's openTime is within another slot
            (slot.closeTime > otherSlot.openTime && slot.closeTime <= otherSlot.closeTime) || // Current slot's closeTime is within another slot
            (slot.openTime <= otherSlot.openTime && slot.closeTime >= otherSlot.closeTime) // Current slot entirely overlaps another slot
          ) {
            overlapError = true; // Mark as overlap
          }
        }
      });

      // If there's an overlap error, apply the error message to both start and end times
      if (overlapError) {
        updatedSlots[index].openTimeErr = "Time slots cannot overlap.";
        updatedSlots[index].closeTimeErr = "Time slots cannot overlap.";
        hasError = true;
      }
    });

    setTimeFields(updatedSlots); // Update the state with the new array
    return hasError;
  };

  const handleSubmit = async (values) => {
    if (values?.errorFields?.length > 0) return;
    if (selectType === "schedule" && validateSlots()) return;

    if (previewImage === "") {
      form.setFields([
        {
          name: "profile_image",
          errors: ["Please select your Profile picture."],
        },
      ]);
      return false;
    }
    values.profile_image = previewImage;
    // values.country_code = countryCodeInput;
    // values.mobile_no = phoneNumberInput;

    let timeFieldsInsertValues = [];
    for (let item of timeFields) {
      if (item.openTime !== "" && item.closeTime !== "") {
        timeFieldsInsertValues.push({
          from: item.openTime,
          to: item.closeTime,
          id: item.id,
          total_trip_distance: item.total_trip_distance,
        });
      }
    }
    if (timeFieldsInsertValues.length > 0) values.time_slots = timeFieldsInsertValues;

    dispatch(changeLoader(true));
    try {
      let url = Apis?.MANAGE_DRIVERS?.CREATE_DRIVERS;
      let method = "post";
      if (id) {
        url = Apis?.MANAGE_DRIVERS?.EDIT_DRIVERS + "/" + id;
        method = "put";
      }
      let response = await globalRequest(url, method, values, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Driver created successfully";
        if (id) msg = "Driver updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        navigate("/manage-driver");
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const getDriverDetail = async (id) => {
    try {
      let response = await globalRequest(Apis.MANAGE_DRIVERS.GET_DRIVERS_DETAIL + "/" + id, "get", {}, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;
        form.setFieldValue("first_name", data?.firstName);
        form.setFieldValue("last_name", data?.lastName);
        form.setFieldValue("email", data?.email);
        // form.setFieldValue("mobile_no", data?.mobileNo);
        form.setFieldValue("zone_id", data?.driverDetail?.zoneId);
        form.setFieldValue("vehicle_type_id", data?.driverDetail?.vehicleTypeId);
        form.setFieldValue("plate_number", data?.driverDetail?.plateNumber);
        form.setFieldValue("min_payout", "" + data?.driverDetail?.minPayout);
        form.setFieldValue("max_distance", "" + data?.driverDetail?.maxDistance);
        form.setFieldValue("price_per_km", "" + data?.driverDetail?.pricePerKm);

        if (data?.driverDetail?.vehicleType?.deliveryType === "schedule") setSelectType(data?.driverDetail?.vehicleType?.deliveryType);

        let mobile = (data?.mobileNo).split("-");
        form.setFieldValue("mobile_no", mobile[1]);
        setPreviewImage(`https://rabbitholebucket.s3.eu-north-1.amazonaws.com/` + data?.driverDetail?.profileImage);

        let slots = [];
        if (data?.driverDetail?.driverTimeSlots.length > 0) {
          // Sort the time slots by `openTime` (item.from) in ascending order
          const sortedSlots = data.driverDetail.driverTimeSlots.sort((a, b) => {
            return a.from.localeCompare(b.from);
          });

          for (let item of sortedSlots) {
            // console.log('item',item);
            slots.push({
              id: item.id,
              openTime: item.from,
              closeTime: item.to,
              total_trip_distance: item.tripDistance,
              openTimeErr: "",
              closeTimeErr: "",
              total_trip_distanceErr: "",
            });
          }
          setTimeFields(slots);
        }
        for (let item of allVehicleType) {
          if (item.id === data?.driverDetail?.vehicleTypeId) setSelectType(item.deliveryType);
        }
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    getAllZones();
    getAllVehicles();
    if (id) getDriverDetail(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const slot = {
    id: 0,
    openTime: "",
    closeTime: "",
    openTimeErr: "",
    closeTimeErr: "",
    total_trip_distance: 0,
    total_trip_distanceErr: "",
  };
  const [timeFields, setTimeFields] = useState([slot]);

  const addTimeField = () => {
    setTimeFields([...timeFields, slot]);
  };

  const removeTimeField = (index) => {
    setTimeFields(timeFields.filter((field, filedIndex) => filedIndex !== index));
  };

  const handleTimeChange = (index, field, value) => {
    let err = `${field}Err`;
    const updatedSlots = timeFields?.map((slot, slotIndex) => {
      if (slotIndex === index) {
        return { ...slot, [field]: value, [err]: "" };
      }
      return slot;
    });
    setTimeFields(updatedSlots);
  };

  // console.log('timeFields',timeFields);

  return (
    <>
      <div className="min-h-[calc(100vh_-_305px)]">
        <Form
          form={form}
          onFinish={handleSubmit}
          onFinishFailed={handleSubmit}
          layout="vertical"
          style={{
            maxWidth: 600,
            width: "100%",
          }}
          initialValues={{
            remember: true,
          }}
          autoComplete="off"
        >
          <Form.Item
            label="First Name"
            name="first_name"
            rules={[
              {
                required: true,
                message: "Please enter your Driver First Name.",
              },
              {
                max: 20,
                message: "Maximum 20 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("first_name", value.trimStart());
                handleInputChange("first_name");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Last Name"
            name="last_name"
            rules={[
              {
                required: true,
                message: "Please enter your Driver Last Name.",
              },
              {
                max: 20,
                message: "Maximum 20 characters",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("last_name", value.trimStart());
                handleInputChange("last_name");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Mobile no"
            name="mobile_no"
            rules={[
              {
                required: true,
                message: "Please enter your Driver Mobile No.",
              },
              {
                min: 9,
                message: "Mobile number must be 9 digits",
              },
              {
                max: 9,
                message: "Mobile number must be no more than 9 digits",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              addonBefore={<span>+966</span>}
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "number|max:9");
                form.setFieldValue("mobile_no", value.trimStart());
                handleInputChange("mobile_no");
              }}
            />
          </Form.Item>
          <Form.Item
            label="E-mail ID"
            name="email"
            rules={[
              {
                required: true,
                message: "Please enter your Email Address.",
              },
              {
                pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                message: "Please enter a valid email address.",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              disabled={id ? true : false}
              size="large"
              onChange={(e) => {
                // let value = Validation.strFormat(e.target.value, "text");
                form.setFieldValue("email", e.target.value.trimStart());
                handleInputChange("email");
              }}
            />
          </Form.Item>
          {!id ? (
            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please enter your Password.",
                },
              ]}
              validateTrigger={"onSubmit"}
            >
              <Input.Password
                size="large"
                onChange={(e) => {
                  form.setFieldValue("password", e.target.value.trimStart());
                  handleInputChange("password");
                }}
              />
            </Form.Item>
          ) : null}
          <Form.Item
            label="Zone"
            name="zone_id"
            rules={[
              {
                required: true,
                type: "number",
                message: "Please Select your Zone.",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Select
              size="large"
              placeholder="Select"
              options={allZones}
              showSearch
              filterOption={(input, allZones) => (allZones?.label ?? "").toLowerCase().includes(input.toLowerCase())}
              onChange={(value) => {
                form.setFieldValue("zone_id", value);
                handleInputChange("zone_id");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Vehicle Type"
            name="vehicle_type_id"
            rules={[
              {
                required: true,
                type: "number",
                message: "Please Select your Vehicle Type.",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Select
              size="large"
              placeholder="Select"
              options={allVehicleType}
              showSearch
              filterOption={(input, allVehicleType) => (allVehicleType?.label ?? "").toLowerCase().includes(input.toLowerCase())}
              onChange={(value, e) => {
                form.setFieldValue("vehicle_type_id", value);
                handleInputChange("vehicle_type_id");
                setSelectType(e.type);
              }}
            />
          </Form.Item>
          <Form.Item
            label="Plate Number"
            name="plate_number"
            rules={[
              {
                required: true,
                message: "Please Select your Plate Number.",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              onChange={(e) => {
                form.setFieldValue("plate_number", e.target.value.trimStart());
                handleInputChange("plate_number");
              }}
            />
          </Form.Item>
          <Row gutter={16}>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                label="Minimum Payout"
                name="min_payout"
                rules={[
                  {
                    required: true,
                    //  type: "number",
                    message: "Please Select your minimum payout.",
                  },
                ]}
                validateTrigger={"onSubmit"}
              >
                <Input
                  size="large"
                  onChange={(e) => {
                    let value = Validation.strFormat(e.target.value, "number");
                    form.setFieldValue("min_payout", value.trimStart());
                    handleInputChange("min_payout");
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                label="Max Distance"
                name="max_distance"
                rules={[
                  {
                    required: true,
                    //  type: "number",
                    message: "Please Select your Max Distance.",
                  },
                ]}
                validateTrigger={"onSubmit"}
              >
                <Input
                  size="large"
                  addonAfter={<span>KM</span>}
                  onChange={(e) => {
                    let value = Validation.strFormat(e.target.value, "number");
                    form.setFieldValue("max_distance", value.trimStart());
                    handleInputChange("max_distance");
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Form.Item
                label="Price/Km"
                name="price_per_km"
                rules={[
                  {
                    required: true,
                    //type: "number",
                    message: "Please Select your Price/Km.",
                  },
                ]}
                validateTrigger={"onSubmit"}
              >
                <Input
                  size="large"
                  onChange={(e) => {
                    let value = Validation.strFormat(e.target.value, "number");
                    form.setFieldValue("price_per_km", value.trimStart());
                    handleInputChange("price_per_km");
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          {selectType && selectType === "schedule"
            ? timeFields?.map((slot, slotIndex) => (
                <>
                  <Row>
                    <Col span={24} className="mb-2 mt-4">
                      <span>Choose Time slot</span>
                    </Col>
                  </Row>
                  <Row key={slot.key} gutter={16} className="items-start">
                    <Col span={7}>
                      {/* <TimePicker className="h-[39px] w-full" /> */}
                      <Select
                        size="large"
                        placeholder="Select"
                        options={selectTime}
                        showSearch
                        filterOption={(input, selectTime) => (selectTime?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                        onChange={(value) => {
                          handleTimeChange(slotIndex, "openTime", value);
                        }}
                        value={slot.openTime || null}
                        className="w-full"
                      />

                      {slot.openTimeErr && <span className="text-red-100">{slot.openTimeErr}</span>}
                    </Col>
                    <Col span={7}>
                      <Select
                        size="large"
                        placeholder="Select"
                        options={selectTime}
                        showSearch
                        filterOption={(input, selectTime) => (selectTime?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                        onChange={(value) => {
                          handleTimeChange(slotIndex, "closeTime", value);
                        }}
                        value={slot.closeTime || null}
                        className="w-full"
                      />
                      {slot.closeTimeErr && <span className="text-red-100">{slot.closeTimeErr}</span>}
                    </Col>
                    <Col span={8}>
                      <Input
                        size="large"
                        value={slot.total_trip_distance || null}
                        placeholder="Distance per trip"
                        onChange={(e) => {
                          let value = Validation.strFormat(e.target.value, "float");
                          // Ensure the value does not exceed 8 characters
                          if (value.length > 8) {
                            value = value.slice(0, 8); // Truncate to 8 characters
                          }
                          handleTimeChange(slotIndex, "total_trip_distance", value);
                        }}
                        addonAfter="KM"
                      />
                      {slot.total_trip_distanceErr && <span className="text-red-100">{slot.total_trip_distanceErr}</span>}
                    </Col>
                    <Col span={2} className="mt-1">
                      {slotIndex === 0 ? (
                        <Button icon={<PlusOutlined />} onClick={addTimeField} type="primary" shape="circle" />
                      ) : (
                        <Button icon={<CloseOutlined />} onClick={() => removeTimeField(slotIndex)} type="primary" danger shape="circle" />
                      )}
                    </Col>
                  </Row>
                </>
              ))
            : null}

          <Form.Item
            label="Upload Image"
            name="profile_image"
            rules={[
              {
                required: id ? false : true,
                message: "Please Select your Upload Image.",
              },
            ]}
            validateTrigger={"onSubmit"}
            className="mt-4"
          >
            <div className="mb-4 h-[102px]">
              <Upload
                listType="picture-card"
                fileList={fileList}
                beforeUpload={() => false}
                onChange={handleUpload}
                onRemove={handleRemove}
                showUploadList={{ showPreviewIcon: true }}
              >
                {fileList.length >= 1 ? null : uploadButton}
              </Upload>
            </div>
          </Form.Item>

          {id ? (
            <Form.Item label="Change Password" className="mt-4">
              <Switch
                checked={changePassword}
                onChange={() => {
                  setChangePassword(!changePassword);
                }}
              />
            </Form.Item>
          ) : null}

          {changePassword ? (
            <>
              <Form.Item
                label="Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please enter your Password.",
                  },
                ]}
                validateTrigger={"onSubmit"}
              >
                <Input.Password
                  size="large"
                  onChange={(e) => {
                    form.setFieldValue("password", e.target.value.trimStart());
                    handleInputChange("password");
                  }}
                />
              </Form.Item>
              <Form.Item
                label="Confirm Password"
                name="confirm-password"
                dependencies={["password"]}
                rules={[
                  {
                    required: true,
                    message: "Please enter your confirm password.",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (getFieldValue("password") !== value && value) {
                        return Promise.reject("Passwords do not match");
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
                validateTrigger={"onSubmit"}
              >
                <Input.Password
                  size="large"
                  onChange={(e) => {
                    form.setFieldValue("confirm-password", e.target.value.trimStart());
                  }}
                />
              </Form.Item>
            </>
          ) : null}
        </Form>
        <div className="flex justify-end gap-3">
          <Button onClick={() => navigate("/manage-driver")}>Cancel</Button>
          <Button type="primary" htmlType="submit" onClick={() => form.submit()}>
            Save
          </Button>
        </div>
      </div>
      <Modal
        open={previewOpen}
        onCancel={() => setPreviewOpen(false)}
        footer={[
          <Button key="back" onClick={() => setPreviewOpen(false)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleCrop}>
            Crop and Upload
          </Button>,
        ]}
      >
        <Cropper src={image} style={{ height: 400, width: "100%" }} aspectRatio={1} guides={false} ref={cropperRef} />
      </Modal>
    </>
  );
};
export default DriverPersonalDetails;
